<template>
<!-- Inizio storico acquisti -->
<div class="ProfileBox">
    <h2><span>{{ this.risorse["TitoloScadenzario"] }}</span><strong>{{ this.risorse["UltimaModifica"] }}: {{ this.oggi }}</strong></h2>
    <!-- Inizio tabella storico ordini -->
    <div class="loader" v-show="this.showLoader"></div> 
    <div class="PaymentStatus Table" v-show="!this.showLoader">
        <table width="100%" border="0" cellspacing="0" cellpadding="0">
            <tbody>
                <tr class="TableHead">
                    <th scope="col" class="PTOrderCode">{{ this.risorse["NumeroDocumento"] }}</th>
                    <th scope="col" class="PTOrderDate">{{ this.risorse["DataDocumento"] }}</th>
                    <th scope="col" class="PTPayment">{{ this.risorse["NumeroRata"] }}</th>
                    <th scope="col" class="PTAmount">{{ this.risorse["ImportoRata"] }}</th>
                    <th scope="col" class="PTPaymentDate">{{ this.risorse["TotaleDocumento"] }}</th>
                    <th scope="col" class="PTPaymentDueDate">{{ this.risorse["DataScadenza"] }}</th> 
                </tr>
                <!-- Inizio repeater -->
                <tr class="TableRow" v-for="(scadenza, index) in this.listaScadenze" :key="index">
                    <td class="PTOrderCode">
                        <small>{{ this.risorse["NumeroDocumento"] }}</small>
                        <span>{{ scadenza.NumeroDocumento}}</span>
                    </td>
                    <td class="PTOrderDate">
                        <small>{{ this.risorse["DataDocumento"] }}</small>
                        <span>{{ scadenza.DataDocumento }}</span>
                    </td>
                    <td class="PTPayment">
                        <small>{{ this.risorse["NumeroRata"] }}</small>                       
                        <span>{{ scadenza.NumeroRata }}</span>
                    </td>
                    <td class="PTAmount">
                        <small>>{{ this.risorse["ImportoRata"] }}</small>
                        <span>{{ this.simboloValuta }} {{ scadenza.ImportoRata}}</span>
                    </td>
                    <td class="PTPaymentDate">
                        <small>{{ this.risorse["TotaleDocumento"] }}</small>
                        <span>{{ this.simboloValuta }} {{ scadenza.TotaleDocumento}}</span>
                    </td>
                    <td class="PTPaymentDueDate">
                        <small>{{ this.risorse["DataScadenza"] }}</small>
                        <span>{{ scadenza.DataScadenza }}</span>
                    </td>
                </tr>
                <!-- Fine repeater -->
               
            </tbody>
        </table>
    </div>
    <!-- Fine tabella storico ordini -->
</div>
<!-- Fine storico acquisti -->

</template>

<script>
import {risorseMixin, valutaMixin} from "@/mixin.js";
import ProfiloService from "@/services/profilo.service.js";
import Scadenza from "@/models/Scadenza.model.js";
import moment from "moment";

export default {
    name: "Scadenzario",
    mixins:[risorseMixin, valutaMixin],
    data(){
        return {
            listaScadenze: [],
            showLoader: true,
            oggi: moment().format("DD/MM/YYYY")
        }
    },
    mounted(){
        ProfiloService.getScadenze(this.$store.getters.getToken, this.$store.getters.getAnagraficaAzienda.CodiceCliente).then(
            data => {
                if(!data){
                    this.$router.push("/")
                }
                else{
                   
                    this.listaScadenze = data.map(m => {
                        let link = new Scadenza();
                        return Object.assign(link, m);
                    }); 
                    this.showLoader = false;                                               
                }               
            }
        );
    }
}
</script>